var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2PlayroomBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.86 54.15a5 5 0 11-9.998 0 5 5 0 019.998 0zM24.12 44l-10 10 4.76 4.76 10-10c3.2-3.2 6.07.37 12.29-.36l-16.7-16.7c-.73 6.3 2.82 9.14-.35 12.3zm27.83-23a14.41 14.41 0 00-11-4.1 18 18 0 00-15.2 10.49l19.78 19.77A18 18 0 0056 32a14.399 14.399 0 00-4.05-11z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Playroom_bis.ce74317a.svg";
export { SvgE2PlayroomBis as ReactComponent };